/*
 *
 * HiddenVariables constants
 *
 */

const scope = `app/HiddenVariables`;
export const FETCH_HIDDEN_VARIABLES_SUCCESS = `${scope}/FETCH_HIDDEN_VARIABLES_SUCCESS`;
export const ADD_HIDDEN_VARIABLE = `${scope}/ADD_HIDDEN_VARIABLE`;
export const UPDATE_HIDDEN_VARIABLE = `${scope}/UPDATE_HIDDEN_VARIABLE`;
export const DELETE_HIDDEN_VARIABLE = `${scope}/DELETE_HIDDEN_VARIABLE`;
export const ADD_HIDDEN_VARIABLE_VALUE = `${scope}/ADD_HIDDEN_VARIABLE_VALUE`;
export const UPDATE_HIDDEN_VARIABLE_VALUE = `${scope}/UPDATE_HIDDEN_VARIABLE_VALUE`;
export const DELETE_HIDDEN_VARIABLE_VALUE = `${scope}/DELETE_HIDDEN_VARIABLE_VALUE`;

export const CREATE_MODAL_MESSAGE_KEY = 'createModal';
export const EDIT_MODAL_MESSAGE_KEY = 'editModal';

export const MODAL_CATEGORIES = {
  CREATE_OR_EDIT: 'createOrEdit',
  DELETE_VARIABLE: 'deleteVariable',
  DELETE_VALUE: 'deleteValue',
};

const testIdPrefix = 'hidden-variables';
export const DATA_TEST_ID = {
  VARIABLE_ACCORDION: `${testIdPrefix}-variable-accordion`,
  GO_TO_RULES: `${testIdPrefix}-go-to-rules`,
  ADD_NEW_VARIABLE: `${testIdPrefix}-add-new-button`,
  EMPTY_VALUES: `${testIdPrefix}-empty-values`,
  MENU_OPENER: `${testIdPrefix}-menu-opener`,
  MENU_EDIT: `${testIdPrefix}-menu-edit`,
  MENU_DUPLICATE: `${testIdPrefix}-menu-duplicate`,
  MENU_DELETE: `${testIdPrefix}-menu-delete`,
  VARIABLE_MODAL: `${testIdPrefix}-modal`,
  VARIABLE_MODAL_CLOSE: `${testIdPrefix}-modal-button-close`,
  VARIABLE_MODAL_CROSS: `${testIdPrefix}-modal-button-cross`,
  VARIABLE_MODAL_SUBMIT: `${testIdPrefix}-modal-button-submit`,
  VARIABLE_MODAL_NAME_EXISTS_MESSAGE: `${testIdPrefix}-modal-name-exists-message`,
  VARIABLE_MODAL_MESSAGE: `${testIdPrefix}-modal-alert-message`,
  VARIABLE_MODAL_LABEL_INPUT: `${testIdPrefix}-modal-label-input`,
  VARIABLE_MODAL_VALUES_INPUT: `${testIdPrefix}-modal-values-input`,
  DELETE_VARIABLE_MODAL: `${testIdPrefix}-delete-modal`,
  DELETE_VARIABLE_MODAL_CLOSE: `${testIdPrefix}-delete-modal-button-close`,
  DELETE_VARIABLE_MODAL_CROSS: `${testIdPrefix}-delete-modal-button-cross`,
  DELETE_VARIABLE_MODAL_SUBMIT: `${testIdPrefix}-delete-modal-button-submit`,
  DELETE_VARIABLE_MODAL_MESSAGE: `${testIdPrefix}-delete-modal-message`,
  VARIABLE_VALUE: `${testIdPrefix}-variable-value-button`,
  VARIABLE_VALUE_NEW: `${testIdPrefix}-variable-value-button-new`,
  VARIABLE_VALUE_DELETE: `${testIdPrefix}-variable-value-button-delete`,
  VARIABLE_VALUE_INPUT: `${testIdPrefix}-variable-value-input`,
};
